// Global Instructions Rule Applied!
//
// The app's DatePicker: AntD's, with typed-date parsing widened to the
// variants people type (see core/utils/dateInputFormats.ts). Every date
// input imports this instead of AntD's DatePicker so the behaviour is one
// standard, the same way Select.jsx standardises allowClear / showSearch.
// RangePicker is passed through with the same format treatment.

import React, { forwardRef } from 'react'
import { DatePicker as AntDatePicker } from 'antd'
import type { DatePickerProps } from 'antd'
import { typedDateFormats } from '../utils/dateInputFormats.ts'

type RangePickerType = typeof AntDatePicker.RangePicker
type RangePickerProps = React.ComponentProps<RangePickerType>

const DatePickerBase = forwardRef<any, DatePickerProps>(({ format, ...props }, ref) => (
  <AntDatePicker ref={ref} {...(props as DatePickerProps)} format={typedDateFormats(format) as DatePickerProps['format']} />
))
DatePickerBase.displayName = 'DatePicker'

const RangePicker = forwardRef<any, RangePickerProps>(({ format, ...props }, ref) => (
  <AntDatePicker.RangePicker
    ref={ref}
    {...(props as RangePickerProps)}
    format={typedDateFormats(format) as RangePickerProps['format']}
  />
))
RangePicker.displayName = 'DatePicker.RangePicker'

const DatePicker = Object.assign(DatePickerBase, { RangePicker })

export default DatePicker
